<template>
  <v-app>
	<v-alert
      border="top"
      color="red lighten-2"
      dark
    >
      {{alertMessage}}
    </v-alert>
    <v-alert
      v-if="warnings.length > 0"
      border="left"
      color="orange darken-1"
      dark
      prominent
      type="warning"
    >
      <div class="text-h6">⚠️ Data Format Warnings</div>
      <div v-for="(warning, index) in warnings" :key="index" class="mt-1">
        {{ warning.message }}
      </div>
    </v-alert>
   <div>

	<v-text-field
    v-model="search"
    append-icon="mdi-magnify"
    label="Search"
    single-line
    hide-details
    ></v-text-field>

    <v-data-table
      :search="search"
      :headers=headers
      :items="unformattedData"
      >
	<template v-slot:item="row">
           <tr>
              <td>{{row.item.name}}</td>
              <td>{{row.item.episode}}</td>
				<td>
					<v-chip  
          v-bind:class = "(row.item.mp4.s480)?' green ma-2':' red ma-2'"
          @click="copyToClipbopard(row.item.mp4.s480, row.item, ' mp4 480')">480</v-chip>
          
					<v-chip 
            v-bind:class = "(row.item.mp4.s720)?' green ma-2':' red ma-2'"
            @click="copyToClipbopard(row.item.mp4.s720, row.item, ' mp4 720')">720
          </v-chip>

					<v-chip 
          v-bind:class = "(row.item.mp4.s1080)?' green ma-2':' red ma-2'"
          @click="copyToClipbopard(row.item.mp4.s1080, row.item, ' mp4 1080')" >1080</v-chip>
				</td>

				<td>
					<v-chip 
            v-bind:class = "(row.item.webm.s480)?' green ma-2':' red ma-2'"
              @click="copyToClipbopard(row.item.webm.s480, row.item, ' webm 480')"
            >480</v-chip>

					<v-chip 
            v-bind:class = "(row.item.webm.s720)?' green ma-2':' red ma-2'"
            @click="copyToClipbopard(row.item.webm.s720, row.item, ' webm 720')"
            >720</v-chip>

					<v-chip 
          v-bind:class = "(row.item.webm.s1080)?' green ma-2':' red ma-2'"
            @click="copyToClipbopard(row.item.webm.s1080, row.item, ' webm 1080')">1080</v-chip>
				</td>
           </tr>

       </template>
      </v-data-table>
		<span> Seconds Since Update {{timeUntilUpdate}}</span>
   </div>
  </v-app>
</template>

<script>

import axios from 'axios';
export default {
  name: 'App',

  components: {
    
  },

  data: () => ({
	timeUntilUpdate:0,
	search:'',
	alertMessage:'',
   warnings:[],
   unformattedData:[],
   formattedData:[],
   headers:[
    {
      text: 'Series',
      value: 'name'
    },
    {
      text: 'Episode',
      value: 'episode'
    },
	{
      text: 'Copy MP4 Link to clipboard',
      value: 'mp4'
    },
	{
      text: 'Copy Webm Link clipboard',
      value: 'webm'
    },
  ]
  }),
  created(){
      this.$vuetify.theme.dark = true;
      this.getContent()

		setInterval(() => {
      this.timeUntilUpdate ++;
      if(this.timeUntilUpdate == 10)	{
        setTimeout(() => {
          this.getContent()
        }, 500);
        this.timeUntilUpdate = 0;
      }
		}, 1000);
    },
    methods:{
      async getContent(){
        axios.get("https://www.source-control.co.uk/cdn/test.php").then((resp)=>{
          this.warnings = [];
          let dataSet = this.removeOpeningArray(resp.data)
          this.unformattedData = this.extractData(dataSet)
        });
      },
      removeOpeningArray(resp){
        let txt = resp.substring(13)
        txt = txt.substring(0,txt.length - 8);
        txt = txt.replaceAll(' ', '');
        txt = txt.replaceAll('\n', '');
        txt = txt.replaceAll('=>Array(','')
        txt = txt.split(/\[(.*?)\]/)

        return txt;
      },
      extractData(masterArray){
        let newMasterArray = [];
        masterArray.forEach(element => {
          if(element != ""){
            newMasterArray.push(element)
          }
        });
        masterArray = newMasterArray;

        let newData = new Array();

        masterArray = masterArray.filter(this.containsSpace)

        let movieType = '';
        let resolution = '';
        let seriesTitle = ''
       
        for (let masterIndex = 0; masterIndex < masterArray.length; masterIndex++) {
           let masterElement = masterArray[masterIndex].trim();

          let isTitle = false;
          let isEpisode = false;
          let isKeyword = ['webm', '1080p', '720p', '480p', 'mp4'].includes(masterElement);
          let isUrl = masterElement.substring(0,4) === "=>ht";

          // Check for series title (with or without vip_ prefix)
          if(masterElement.includes('vip_')){
              isTitle = true;
              seriesTitle = masterElement.replaceAll('vip_','').replaceAll('_',' ')
          } else if(!isKeyword && !isUrl && !masterElement.includes('episode_')) {
              // Series without vip_ prefix - treat as title but add warning
              isTitle = true;
              seriesTitle = masterElement.replaceAll('_',' ')
              this.warnings.push({
                type: 'missing_prefix',
                series: seriesTitle,
                message: `Series "${seriesTitle}" is missing the vip_ prefix in the API data`
              });
          }

          // Check for episode
          if(!isTitle && !isKeyword && !isUrl && masterElement.includes('episode_')){
            isEpisode = true;
            newData.push({
                name: seriesTitle + ' - ' + masterArray[masterIndex].replaceAll("_",' '),
                episode: masterArray[masterIndex].replaceAll("_",' '),
                mp4:{
                  s480:'',
                  s720:'',
                  s1080:''
                },
                webm:{
                  s480:'',
                  s720:'',
                  s1080:''
                }
            })
          }

          // Handle keywords and URLs
          if(!isTitle && !isEpisode){
            switch (masterElement) {
              case 'mp4':
                movieType = 'mp4';
                break;
              case 'webm':
                movieType = 'webm';
                break;
              case '480p':
                resolution = 's480';
                break;
              case '720p':
                resolution = 's720';
                break;
              case '1080p':
                resolution = 's1080';
                break;
              default:
                if(newData.length > 0 && movieType && resolution){
                  newData[newData.length -1][movieType][resolution] = masterElement.replace('=>', '').replaceAll(')','')
                }
                break;
            }
          }
        }
        return newData;
      },
      containsSpace(value){
        return value != "";
      },
	copyToClipbopard(link, item, message){
		this.alertMessage = item.name + ' - ' +  message +  ' copied to clipboard'
		navigator.clipboard.writeText(link);
	}
    }

};
</script>
